import { ApolloLink } from '@apollo/client'
import moment from 'moment'

import { sendLogFromApolloLink } from '../../logger/btimeLogs/logFromApolloLink'

export const loggerLink = new ApolloLink((operation, forward) => {
  const happenedAt = moment().toISOString()
  operation.setContext({ happenedAt })
  return forward(operation).map(data => {
    sendLogFromApolloLink(operation, data)
    return data
  })
})
